import { useAuth } from '../context/AuthContext';

// Custom hook to check if the user has any of the specified permissions
export function useHasAnyPermission(permissions = []) {
  const { user } = useAuth(); // This is a hook, so it's fine here.
  if (!user || !user.permissions) return false;

  try {
    // Permissions might be a JSON string from the backend, or already an array.
    let userPermissions;
    
    if (typeof user.permissions === 'string') {
      // Handle empty string or whitespace
      if (!user.permissions.trim()) {
        return false;
      }
      
      // Clean up the string - remove any leading/trailing characters that might cause issues
      let cleanPermissions = user.permissions.trim();
      
      // Check if it starts with a non-JSON character and try to fix it
      if (!cleanPermissions.startsWith('[') && !cleanPermissions.startsWith('{')) {
        // If it's just a plain string with permission names, treat it as such
        return permissions.some(permission => cleanPermissions.includes(permission));
      }
      
      userPermissions = JSON.parse(cleanPermissions);
    } else {
      userPermissions = user.permissions;
    }

    // Ensure userPermissions is an array before calling .some or .includes
    return Array.isArray(userPermissions) && permissions.some(permission => userPermissions.includes(permission));
  } catch (e) {
    console.error("Error parsing permissions in useHasAnyPermission:", e);
    console.error("Raw permissions data:", user.permissions);
    console.error("Permissions type:", typeof user.permissions);
    console.error("Permissions length:", user.permissions?.length);
    console.error("First few characters:", user.permissions?.substring(0, 50));
    
    // Fallback: if permissions is a string, try to find the permission names directly
    if (typeof user.permissions === 'string') {
      return permissions.some(permission => user.permissions.includes(permission));
    }
    
    return false;
  }
}